import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookupsObjective = async () => {
	const { data } = await axios.get(`${API}/app/maintainer/objective/lookups`);
	return data;
};

export const getObjectives = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/objective/`, { params: filters });
	return data;
};

export const getObjectiveById = async (filters, element_id) => {
	const { data } = await axios.get(`${API}/app/maintainer/objective/${element_id}`, { params: filters });
	return data;
};

export const saveObjective = async (params) => {
	let URL = `${API}/app/maintainer/objective/`;

	if (params.id != null) {
		const { data } = await axios.patch(URL + params.id, params);
		return { data, params };
	}

	const { data } = await axios.post(URL, params);
	return { data, params };
};

export const deleteObjective = async (params) => {
	const { data } = await axios.delete(`${API}/app/maintainer/objective/${params.selected}`);
	return data;
};
